import { render } from "./GCBMConfigurations.vue?vue&type=template&id=9263418a"
import script from "./GCBMConfigurations.vue?vue&type=script&lang=js"
export * from "./GCBMConfigurations.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/flint.ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__